import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/main/HomeView.vue'
import {TokenStorage} from "@/data/token";
import axios from "axios";
import store from "@/store";

const routes = [
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '/main',
    name: 'main',
    redirect: '/main/home',
    component: () => import('../views/index'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('../views/main/HomeView'),
      },
      {
        path: 'contacts',
        name: 'contacts',
        component: () => import('../views/main/ContactView')
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('../views/main/NewsView')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('../views/main/AboutView')
      },
      {
        path: 'catalog',
        name: 'catalog',
        component: () => import('../views/main/CatalogView')
      },
      {
        path: 'catalog/:id',
        name: 'catalogItem',
        component: () => import('../views/main/ItemView')
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('../views/main/OrderView')
      },
      {
        path: ":catchAll(.*)",
        name: "NotFound",
        redirect: '/'
      }
    ]
  },
  {
    path: '/admin-panel',
    name: 'admin',
    redirect: '/admin-panel/items',
    component: () => import('../views/admin/index'),
    children: [
      {
        path: 'items',
        name: 'admin.items',
        component: () => import('../views/admin/ItemsDashboard/ItemsDashboard')
      },
      {
        path: 'sections',
        name: 'admin.sections',
        component: () => import('../views/admin/SectionsDashboard/SectionsDashboard')
      },
      {
        path: 'news',
        name: 'admin.news',
        component: () => import('../views/admin/NewsDashboard/NewsDashboard')
      },
      {
        path: 'characteristics',
        name: 'admin.characteristics',
        component: () => import('../views/admin/CharacteristicsDashboard/CharacteristicsDashboard')
      },
      {
        path: 'orders',
        name: 'admin.orders',
        component: () => import('../views/admin/OrdersDashboard/OrderDashboard')
      },
      {
        path: ":catchAll(.*)",
        name: "NotFound",
        redirect: '/'
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    redirect: '/user/login',
    component: () => import('../views/user/index'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('../views/user/login/LoginView')
      }
    ]
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from) => {
  if(to.path.includes('admin')){
    let token = store.getters.getToken
    if(!token){
      return {name: 'login'}
    }else{
      try {
        let role = await store.dispatch('loadRole')
        if(role.data !== 'ROLE_ADMIN'){
          console.log('logout')
          store.commit('changeToken', null)
          return {name: 'home'}
        }else{
          console.log('valid role')
        }
      }catch (e){
        return {name: 'login'}
      }
    }
  }
})

export default router
